const appTailorsI18nDe = {};

export default appTailorsI18nDe;
